import { useIdToText } from "../../hooks/IdToText";
import { TextIcon } from "../text_icon";
import { OpportunityInfoContainer } from "./styled";

interface IOpportunityInformation {
  address: string;
  typeWorkTimeId: string;
  typeWorkId: string;
}

export default function OpportunityInformation({ address, typeWorkTimeId, typeWorkId }: IOpportunityInformation) {
  const { converIdToText } = useIdToText();

  return (
    <OpportunityInfoContainer>
      <div>
        <TextIcon
          type="location"
          text={`Peru, ${converIdToText(address, "geoDepartments")}`}
        />
      </div>
      <div>
        <TextIcon
          type="hours"
          text={converIdToText(typeWorkTimeId, "workHours")}
        />
      </div>
      <div>
        <TextIcon
          type="workMode"
          text={converIdToText(typeWorkId, "workPlace")}
        />
      </div>
    </OpportunityInfoContainer>
  );
}